<div class="modal-header" *ngIf="isModal">
  <h5 class="modal-title">{{'container.editTitle' | translate}}</h5>
  <div>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div [ngClass]="{'modal-body': isModal, 'card': !isModal}">
  <div [ngClass]="{'card-body': !isModal}">
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle mb-0">
        <thead>
        <tr>
          <th>{{'lavorazioni.voce' | translate}}</th>
          <th scope="col">{{'lavorazioni.disponibilita' | translate}}</th>
          <th scope="col">{{'container.quantita' | translate}}</th>
          <th scope="col" >{{'container.azioni' | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of List">
          <td class="align-middle">
            <span class="font-14">{{item.voce}}</span>
          </td>
          <td class="align-middle">
            <span class="font-14">{{item.disponibilita}}</span>
          </td>
          <td class="align-middle">
            <span>
              <input [(ngModel)]="item.assegnabili" max="{{item?.disponibilita}}" min="0" placeholder="quantita" type="number" name="quantita" class="form-control">
            </span>
          </td>
          <td class="align-middle">
            <a (click)="Add(item)" href="javascript:void(0)" ngbTooltip="Aggiungi" class="link font-16 text-info font-medium mr-2">
              <i class="fas fa-plus-circle"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
